module.exports = __webpack_public_path__ + "img/loading.8e04b50b.png";